<script setup>
import '@/styles/3-modules/upstox-redesign-base.scss'
import '@/styles/css/revamp-trade.scss'
import { onMounted } from 'vue';
onMounted(()=>{
  
      // 初始化 Owl Carousel
      const owl = $('.owl-carousel').owlCarousel({
        loop: false, // 循环播放
        margin: 10, // 幻灯片之间的间距
        nav: true, // 显示导航按钮
        dots: true, // 禁用默认分页点
        navText:[`<img
                class="mx-auto"
                src="https://upstox.com/app/themes/upstox/dist/img/new-trade/arrow-left.png"
                height="16"
                width="16"
              />`,`<img
              class="mx-auto"
                src="https://upstox.com/app/themes/upstox/dist/img/new-trade/arrow-right.png"
                height="16"
                width="16"
              />`],
        responsive: {
          0: {
            items: 1, // 在小屏幕上显示 1 个幻灯片
          },
          600: {
            items: 3, // 在中等屏幕上显示 3 个幻灯片
          },
          1000: {
            items: 5, // 在大屏幕上显示 5 个幻灯片
          },
        },
      });
      const dotsContainer = $('.owl-dots');
      dotsContainer.find('.owl-dot.active').append('<div id="countDitext-slider" class="countDitext-slider">1/9</div>');
      owl.on('changed.owl.carousel', function (event) {
        const currentIndex = event.item.index;
        dotsContainer.find('.owl-dot.active').append('<div id="countDitext-slider" class="countDitext-slider">'+(currentIndex+1)+'/9</div>');
        // dotsContainer.find('.dot[data-index="' + currentIndex + '"]').addClass('active');
      });
})
</script>
<template>
  <main class="upstox-design-base upstox-homepage update-trading-page">
    <!-- Banner Section Start -->
    <section class="trader-future-main">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-xs-12 content-left">
            <h5>Powerful Trading Made Simple</h5>
            <h1>
              Enjoy trading in
              <span class="text-slider">
                <ul class="text-slides">
                  <li class="font-purple quotes text-slide">Futures</li>
                  <li class="font-purple quotes text-slide">Options</li>
                  <li class="font-purple quotes text-slide">Currencies</li>
                  <li class="font-purple quotes text-slide">Commodities</li>
                  <li class="font-purple quotes text-slide">Futures</li>
                </ul>
              </span>
            </h1>
            <div class="equity-main">
              <div class="equity-sub one">
                <h3 class="price"><span class="rupee">₹</span>0</h3>
                <p>Commissions on Mutual Funds and IPO</p>
              </div>
              <div class="equity-sub two">
                <h3 class="price"><span class="rupee">₹</span>20</h3>
                <p>Per order on Equity, F&amp;O, Commodity and Currency</p>
              </div>
            </div>
            <div class="add-number-form">
              <form onsubmit="return proceedWithLazyLogin(event, this)">
                <div class="form-row">
                  <div class="phone-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/new-trade/India.png"
                      alt="flag"
                      height="12"
                      width="16"
                    />
                  </div>
                  <div class="form-group invest-group">
                    <input
                      type="tel"
                      onkeypress="return isNumber(event)"
                      name="phone"
                      id="txtcontact"
                      class="form-control"
                      maxlength="10"
                      placeholder="Mobile number"
                    />
                  </div>
                  <button
                    type="submit"
                    class="btn prple_btn animation-btn desktop-btn"
                  >
                    Open FREE Demat Account Now
                  </button>
                </div>
                <div class="error-message" id="error-message"></div>
                <p class="desktop-content">
                  By signing up, you agree to receive transaction updates from
                  Upstox.
                </p>
              </form>
            </div>
          </div>
          <div class="col-sm-6 col-xs-12 image-right">
            <img
              src="https://upstox.com/app/themes/upstox/dist/img/new-trade/trader-future-banner.webp"
              alt="trader-banner"
              height="470"
              width="714"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- End Banner Section Start -->
    <!-- start of average app section -->
    <section class="average-app">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-xs-12 average-sub">
            <ul>
              <li>
                <h5>
                  4.5+
                  <img
                    class="star-yellow"
                    src="https://upstox.com/app/themes/upstox/dist/img/new-trade/star-yellow.png"
                    alt="Uplink Banner Right"
                    width="16"
                    height="16"
                  />
                </h5>
                <p>Average <br />App Rating</p>
              </li>
              <li>
                <h5>
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/new-trade/ratan-tata.png"
                    alt="Uplink Banner Right"
                    width="32"
                    height="32"
                  />
                </h5>
                <p>Backed by <br />Ratan Tata</p>
              </li>
              <li>
                <h5>1 Cr+ Customers</h5>
                <p>Loved &amp; Trusted <br />by Indians</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- end of average app section -->
    <!-- start of image mob section -->
    <section class="mob-banner d-none">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-xs-12 mob-banner-imag">
            <img
              src="https://upstox.com/app/themes/upstox/dist/img/new-trade/trader-future-banner.webp"
              alt="trader-banner"
              width="648"
              height="426"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- end of image mob section -->

    <section class="team_sec main_word take_word">
      <div class="mbile-hide">
        <div class="team-sec-heading-content">
          <h2 class="h2_heading team-sec-title">Discover. Analyse. Trade.</h2>
          <p>The only platform you'll need for all your trading needs.</p>
        </div>
        <!-- <h3 class="mobile-content-heading">Some of the best features on the market</h3> -->
        <div
          class="team_mb_slider global_slick_dots owl-carousel owl-theme owl-loaded owl-drag"
        >
          <div class="owl-stage-outer">
            <div
              class="owl-stage"
              style="
                transform: translate3d(0px, 0px, 0px);
                transition: all;
                width: 3274px;
                padding-left: 1px;
                padding-right: 1px;
              "
            >
              <div
                class="owl-item active"
                style="width: 347.5px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card">
                    <div class="slider-text-content">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/360.webp"
                        alt="f&amp;O-discover"
                        loading="lazy"
                        width="646"
                        height="897"
                      />
                    </div>
                    <div class="team-img-text-content">
                      <h5>Chart 360</h5>
                      <p>
                        Experience the power of desktop trading from your
                        mobile.
                      </p>
                      <a
                        class="explore-btn-main"
                        href="/trade-on-charts/"
                        >Explore Now</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="owl-item active"
                style="width: 347.5px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card">
                    <div class="slider-text-content">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/discover-chain.webp"
                        alt="f&amp;O-discover"
                        loading="lazy"
                        width="646"
                        height="897"
                      />
                    </div>
                    <div class="team-img-text-content">
                      <h5>F&amp;O Discover</h5>
                      <p>
                        To find new trading opportunities via Smartlists,
                        Futures Heatmaps, etc.
                      </p>
                      <a
                        class="explore-btn-main"
                        href="/fno-discovery/"
                        >Explore Now</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="owl-item active"
                style="width: 347.5px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card">
                    <div class="slider-text-content">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/option-chain.webp"
                        alt="option-chain"
                        loading="lazy"
                        width="371"
                        height="516"
                      />
                    </div>
                    <div class="team-img-text-content">
                      <h5>Option Chain</h5>
                      <p>
                        Customisable Option Chain with data points like PCR,
                        India VIX, Max Pain.
                      </p>
                      <a
                        class="explore-btn-main"
                        href="/option-chain/"
                        >Explore Now</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="owl-item active"
                style="width: 347.5px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card">
                    <div class="slider-text-content">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/tick-chain.webp"
                        alt="tick-by-tick-charting-data"
                        loading="lazy"
                        width="371"
                        height="516"
                      />
                    </div>
                    <div class="team-img-text-content">
                      <h5>Tick-by-Tick Charting Data</h5>
                      <p>
                        Accurate Tick-by-tick charting data powered by Upstox
                        for Intraday.
                      </p>
                      <a
                        class="explore-btn-main"
                        href="/tick-by-tick/"
                        >Explore Now</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="owl-item" style="width: 347.5px; margin-right: 16px">
                <div>
                  <div class="card team_mb_card">
                    <div class="slider-text-content">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/basket-order.webp"
                        alt="basket-order"
                        loading="lazy"
                        width="371"
                        height="516"
                      />
                    </div>
                    <div class="team-img-text-content">
                      <h5>Basket Orders</h5>
                      <p>
                        Place up to 20 orders in Stocks, Options, Futures,
                        Commodities, etc.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="owl-item" style="width: 347.5px; margin-right: 16px">
                <div>
                  <div class="card team_mb_card">
                    <div class="slider-text-content">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/gtt-chain.webp"
                        alt="gtt"
                        loading="lazy"
                        width="371"
                        height="516"
                      />
                    </div>
                    <div class="team-img-text-content">
                      <h5>GTT</h5>
                      <p>
                        Plan your entry and exit in advance and don’t let
                        emotions get in the way.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="owl-item" style="width: 347.5px; margin-right: 16px">
                <div>
                  <div class="card team_mb_card">
                    <div class="slider-text-content">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/margin-chain.webp"
                        alt="margin-trading-facility"
                        loading="lazy"
                        width="371"
                        height="516"
                      />
                    </div>
                    <div class="team-img-text-content">
                      <h5>Margin Trading Facility</h5>
                      <p>
                        Get 50% funds from us to buy &amp; hold your favourite
                        stocks for 365 days.
                      </p>
                      <a
                        class="explore-btn-main"
                        href="/margin-trading-facility/"
                        >Explore Now</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="owl-item" style="width: 347.5px; margin-right: 16px">
                <div>
                  <div class="card team_mb_card">
                    <div class="slider-text-content">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/pledge-chain.webp"
                        alt="margin-pledge"
                        loading="lazy"
                        width="371"
                        height="516"
                      />
                    </div>
                    <div class="team-img-text-content">
                      <h5>Margin Pledge</h5>
                      <p>
                        Get 100% collateral for F&amp;O trading by pledging
                        Stocks, ETFs, etc.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="owl-item" style="width: 347.5px; margin-right: 16px">
                <div>
                  <div class="card team_mb_card">
                    <div class="slider-text-content">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/made-chain.webp"
                        alt="option-strategies"
                        loading="lazy"
                        width="371"
                        height="516"
                      />
                    </div>
                    <div class="team-img-text-content">
                      <h5>Ready-made Option Strategies</h5>
                      <p>
                        Get pre-curated strategies in NIFTY &amp; BANK NIFTY
                        with limited risks.
                      </p>
                      <a
                        class="explore-btn-main"
                        href="/option-strategies/"
                        >Explore Now</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="owl-dots">
            <button role="button" class="owl-dot active">
              <span></span>
              <div id="countDitext-slider" class="countDitext-slider">1/9</div>
              <span class="offscreen">upstox 1</span></button
            ><button role="button" class="owl-dot">
              <span></span>
              <div id="countDitext-slider" class="countDitext-slider">2/9</div>
              <span class="offscreen">upstox 2</span></button
            ><button role="button" class="owl-dot">
              <span></span>
              <div id="countDitext-slider" class="countDitext-slider">3/9</div>
              <span class="offscreen">upstox 3</span>
            </button>
          </div> -->
        </div>
        <div class="trading-btn">
          <a
            class="trading-button"
            href="https://wa.me/+917092362098"
            >Start Trading</a
          >
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-xs-12 heading-analysis">
            <h3>And many more...</h3>
            <ul class="many-more">
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/analys.png"
                  alt="analysis"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>OI analysis</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/slicing.png"
                  alt="slicing"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Order Slicing</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/greek.png"
                  alt="greek"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Option Greeks</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/alert.png"
                  alt="alert"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Price Alerts</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/ledger.png"
                  alt="ledger"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Simplified Ledger</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/smartlist.png"
                  alt="smartlist"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Smartlists</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/market-order.png"
                  alt="market-order"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>After-Market-Orders</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/breakdown.png"
                  alt="breakdown"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Funds breakdown</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/analys.png"
                  alt="analys"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Position Analysis</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/option.png"
                  alt="option"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Affordable Options</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/heatmap.png"
                  alt="heatmap"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Heatmap</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/indices.png"
                  alt="indices"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>Global Indices</p>
              </li>
              <li>
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/activity.png"
                  alt="activity"
                  loading="lazy"
                  height="20"
                  width="20"
                />
                <p>FII/DII activity</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- start of transparent pricing -->
    <section class="transparent-pricing">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 heading">
            <h3>Transparent pricing, no hidden charges</h3>
          </div>
        </div>
        <div class="row transparent-row">
          <div class="col-md-3 col-sm-6">
            <div class="transparent-sub one">
              <h4><span class="rupee">₹</span>0</h4>
              <h5>Account Opening</h5>
              <p>Demat + Trading</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="transparent-sub one">
              <h4><span class="rupee">₹</span>0</h4>
              <h5>Commission</h5>
              <p>Mutual Funds and IPOs</p>
            </div>
          </div>

          <div class="col-md-3 col-sm-6">
            <div class="transparent-sub one">
              <h4><span class="rupee">₹</span>20</h4>
              <h5>Brokerage</h5>
              <p>Equity, F&amp;O, Commodity and Currency orders</p>
            </div>
          </div>
          <p class="applicable">
            ZERO AMC is applicable for newly onboarded customers in the first
            year
          </p>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xs-12 brokerage-calc">
            <h5>Calculate brokerage and margin with these calculators</h5>
            <ul class="tag">
              <li>
                <a href="/calculator/brokerage-calculator/"
                  >Brokerage Calculator</a
                >
              </li>
              <!-- <li>
                <a href="/calculator/span-calculator/"
                  >Span Calculator</a
                >
              </li> -->
              <li>
                <a href="/calculator/option-strategy-builder/"
                  >Option Strategy Builder</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- end of transparent pricing -->
    <!-- start of pro mobile app section -->
    <section class="pro-mobile-app">
      <div class="container">
        <div class="row">
          <div class="col-sm-3">
            <div class="mobile-sub one">
              <div class="icon-image">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/mobile.png"
                  alt="mob-icon"
                  width="14"
                  height="14"
                  loading="lazy"
                />
              </div>
              <h4>Pro Mobile App</h4>
              <p>One of India’s highest-rated trading apps</p>
              <div class="scan-image-content">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/qr-code.png"
                  alt="scan-image"
                  width="78"
                  height="78"
                />
                <div class="img-content-scan">
                  <p>Available on</p>
                  <ul>
                    <li>
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/playstore.png"
                        alt="playstore"
                        loading="lazy"
                        width="16"
                        height="16"
                      />
                    </li>
                    <li>
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/new-trade/Apple.png"
                        alt="apple"
                        loading="lazy"
                        width="16"
                        height="16"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mobile-sub two">
              <div class="icon-image">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/desktop_mac.png"
                  alt="mob-icon"
                  width="20"
                  height="20"
                  loading="lazy"
                />
              </div>
              <h4>Pro Desktop Platform</h4>
              <p>With all mobile trading features and more</p>
              <div class="img-content-scan">
                <a
                  class="explore"
                  href="/upstox-pro-web-online-trading/"
                  >Explore</a
                >
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mobile-sub three">
              <div class="icon-image">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/new-uplink.png"
                  alt="mob-icon"
                  width="32"
                  height="12"
                  loading="lazy"
                />
              </div>
              <h4>Trading API</h4>
              <p>Fast, secure, free APIs by Upstox</p>
              <div class="img-content-scan">
                <a class="explore" href="/uplink/">Explore</a>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mobile-sub four">
              <div class="icon-image">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/trading-x.png"
                  alt="mob-icon"
                  width="24"
                  height="12"
                  loading="lazy"
                />
              </div>
              <h4>TradingView X Upstox</h4>
              <p>Advanced features such as multi-chart setup</p>
              <div class="img-content-scan">
                <a
                  class="explore"
                  href="/free-chart-view-for-live-trading/"
                  >Explore</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- end of pro mobile app section -->

    <section class="trading-video">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-xs-12 heading">
            <h3>New to trading?</h3>
            <p>
              UpSkill with us - we cover topics for beginners and pro traders.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- start of follow courses -->
    <section class="follow-courses">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-xs-12 follow-courses-sub one">
            <a href="/uplearn/">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/new-trade/icc.webp"
                alt="icc"
                class="desktop-visible"
                width="535"
                height="219"
                loading="lazy"
              />
              <picture>
                <source
                  srcset="
                    https://upstox.com/app/themes/upstox/dist/img/new-trade/icc-mob.webp
                  "
                  type="image/webp"
                />
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/icc-mob.png"
                  alt="icc-mob"
                  class="mobile-visible"
                  loading="lazy"
                  width="656"
                  height="384"
                />
              </picture>
              <div class="content">
                <h4>Follow our courses</h4>
                <p>Self-study guide to Option Trading along with quizzes</p>
              </div>
            </a>
          </div>
          <div class="col-sm-6 col-xs-12 follow-courses-sub two">
            <a href="/investor-masterclass/">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/new-trade/trade-feature.webp"
                alt="trade-feature"
                width="535"
                height="219"
                class="desktop-visible"
                loading="lazy"
              />
              <picture>
                <source
                  srcset="
                    https://upstox.com/app/themes/upstox/dist/img/new-trade/trade-feature-mob.webp
                  "
                  type="image/webp"
                />
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/new-trade/trade-feature-mob.png"
                  alt="trade-feature-mob"
                  class="mobile-visible"
                  loading="lazy"
                  width="656"
                  height="384"
                />
              </picture>
              <div class="content">
                <h4>Join our online sessions</h4>
                <p>
                  Risk Management, Options Trading, Technical Analysis and More
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
    <!-- end of follow courses -->
  </main>
</template>

<style scoped>
</style>
